module.exports = __webpack_public_path__ + "img/share-sina.3b695fdc.png";